import JoditEditor, { IJoditEditorProps } from "jodit-react"
import { useEffect, useMemo, useState } from "react"
interface RichTextEditorProps {
  value: string
  onChange(newContent: string): void

  fullHeight?: boolean
}
const RichTextEditor = (props: RichTextEditorProps) => {
  const { value, onChange, fullHeight } = props
  const [internalValue, setInternalValue] = useState(value)

  useEffect(() => {
    if (internalValue) {
      return
    }
    setInternalValue(value)
  }, [value])

  const options = [
    "paragraph",
    "|",
    "bold",
    "italic",
    "|",
    "ul",
    "ol",
    "|",
    "font",
    "fontsize",
    "|",
    "outdent",
    "indent",
    "align",
    "|",
    "hr",
    "|",
    "fullsize",
    "brush",
    "|",
    "table",
    "link",
    "|",
    "undo",
    "redo",
  ]

  const config: IJoditEditorProps["config"] = {
    defaultActionOnPaste: "insert_as_html",
    // options that we defined in above step.
    buttons: options,
    height: "100%",
    direction: "rtl",
    showTooltip: true,
    controls: {
      paragraph: {
        list: {
          p: "Normal",
          h1: "Heading 1",
          h2: "Heading 2",
          h3: "Heading 3",
          h4: "Heading 4",
          blockquote: "Quote",
        },
      },
    },
  }

  return useMemo(
    () => (
      <JoditEditor
        className={
          fullHeight ? "richtext-editor fullheight" : "richtext-editor"
        }
        value={internalValue || ""}
        config={config}
        onChange={onChange}
      />
    ),
    [internalValue],
  )
}

export default RichTextEditor
